import ReducerBuilder from 'classes/ReducerBuilder';
import {ActionTypes} from './actions';

const initialState = {
  isOpen: false,
  prizeId: null
};

export default ReducerBuilder.make(initialState)
  .forType(ActionTypes.OPEN_PRIZE_CHALLENGES_MODAL)
  .reduce((state, action) => {
    state.isOpen = true;
    state.prizeId = action.prizeId;
  })
  .forType(ActionTypes.CLOSE_PRIZE_CHALLENGES_MODAL)
  .reduce((state, action) => {
    state.isOpen = false;
    state.prizeId = null;
  })
  .build();



// WEBPACK FOOTER //
// ./public/components/PrizeChallengesModal/reducer.js